import lock from '../../shared/schema.lock.json' with { type: 'json' };

// The names hold across schema versions: a new version migrates these databases in place
// (src/lib/schemaMigrations.ts). e2e imports this file from Node.
export const APP_VERSION = lock.versions[lock.versions.length - 1].version;
export const APP_STORE = 'rosa-house-store';
export const PHOTO_QUEUE_DB = 'rosa-house-photo-queue';
export const IDENTIFY_QUEUE_DB = 'rosa-house-identify-queue';
